/**
 * Generate an appropriate ID for an element.
 * @param elementName 
 * @returns 
 */
const generateLocator = (...terms: string[]): string => (
  `${terms.map(t => t
    .toLowerCase()
    .replace(/[^\s\w-]/g, '')
    .replace(/(\s|\W|_)/g, '-')).join('-')}`
);

export default generateLocator;
